import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "../../../App.css";
import { apiPostAuth } from "../../../utils/api";

export default function AppleAppDetailPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const appId = location.state?.appId || "";

  const [appName, setAppName] = useState("");
  const [supportEmail, setSupportEmail] = useState("");
  const [developerPrompt, setDeveloperPrompt] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    
    e.preventDefault();
    setErrorMessage("");

    if (!appName.trim() || !supportEmail.trim()) {
      setErrorMessage("App Name and Support Email are required.");
      return;
    }

    setLoading(true);
    try {
      const response = await apiPostAuth("apple_apps/add_app_finish.php", {
        app_id: appId,
        app_name: appName,
        app_support: supportEmail,
        developer_prompt: developerPrompt,
      });
      if (response.result === 1) {
        // Navigate to app-specific Google Play Review page
        navigate(`/dashboard/app-store-review/${appId}`);
      } else {
        setErrorMessage(response.message || "Failed to save app details.");
      }
    } catch (error) {
      setErrorMessage("Oops, something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: "20px" }}>
      <h1 style={{ fontSize: "1.8rem", marginBottom: "10px", color: "#1f2937" }}>
        App Details
      </h1>
      <p style={{ fontSize: "1rem", marginBottom: "20px", color: "#4b5563" }}>
        Provide details for App ID <strong>{appId}</strong>.  
        These details will be used in automated responses, so please ensure they are accurate.
      </p>

      <div
        style={{
          backgroundColor: "#fff",
          padding: "30px 20px",
          borderRadius: "8px",
          boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
          width: "90%",
        }}
      >
        <form onSubmit={handleSubmit}>
          {/* App Name */}
          <div style={{ marginBottom: "20px" }}>
            <label
              htmlFor="appName"
              style={{ display: "block", marginBottom: "6px", fontWeight: "500" }}
            >
              App Name
            </label>
            <input
              type="text"
              id="appName"
              value={appName}
              onChange={(e) => setAppName(e.target.value)}
              placeholder="e.g., My Awesome App"
              style={{
                width: "90%",
                padding: "10px",
                border: "1px solid #ccc",
                borderRadius: "6px",
                fontSize: "1rem",
              }}
            />
            <p style={{ fontSize: "0.85rem", color: "#6b7280", marginTop: "4px" }}>
              This name will be used when the AI refers to your app in responses.
            </p>
          </div>

          {/* Support Email */}
          <div style={{ marginBottom: "20px" }}>
            <label
              htmlFor="supportEmail"
              style={{ display: "block", marginBottom: "6px", fontWeight: "500" }}
            >
              App Support Email
            </label>
            <input
              type="email"
              id="supportEmail"
              value={supportEmail}
              onChange={(e) => setSupportEmail(e.target.value)}
              placeholder="support@example.com"
              style={{
                width: "90%",
                padding: "10px",
                border: "1px solid #ccc",
                borderRadius: "6px",
                fontSize: "1rem",
              }}
            />
            <p style={{ fontSize: "0.85rem", color: "#6b7280", marginTop: "4px" }}>
              This email will be included in responses where users are encouraged
              to contact support or provide additional details.
            </p>
          </div>

          <div style={{ marginBottom: "20px" }}>
            <label
                htmlFor="developerPrompt"
                style={{ display: "block", marginBottom: "6px", fontWeight: "500" }}
            >
                Developer Prompt (Optional)
            </label>
            <textarea
                id="developerPrompt"
                value={developerPrompt}
                onChange={(e) => setDeveloperPrompt(e.target.value)}
                placeholder="Directly tell the users to contact the support if the user don'\t like other users behaviour"
                rows="4"
                style={{
                width: "90%",
                padding: "10px",
                border: "1px solid #ccc",
                borderRadius: "6px",
                fontSize: "1rem",
                resize: "vertical",
                }}
            />
            <p style={{ fontSize: "0.85rem", color: "#6b7280", marginTop: "4px" }}>
                This prompt will be <strong>appended</strong> to the system's AI prompt to help customize
                responses for your app.  
                <strong> If left empty</strong>, a default generalized prompt will be used.  
                Use this field if your app has unique features or a specific case you'd like 
                to add to the AI's knowledge. Using <strong>English</strong> is highly recommended. This prompt can be updated and simulated.
            </p>
            </div>

          {errorMessage && (
            <p style={{ color: "red", marginBottom: "10px" }}>{errorMessage}</p>
          )}

          <button
            type="submit"
            className="primary-button"
            style={{ width: "160px" }}
            disabled={loading}
          >
            {loading ? "Saving..." : "Save Details"}
          </button>

          
          <p style={{ fontSize: "0.85rem", marginTop: "8px", color: "#6b7280" }}>
            *This step is just for setup and does not start automation. These informations can be updated later.
          </p>
        </form>
      </div>
    </div>
  );
}
